import { Typography } from 'antd';

import '@app/components/Error403Unauthorized/styles/Error403Unauthorized.desktop.scss';
import '@app/components/Error403Unauthorized/styles/Error403Unauthorized.mobile.scss';
import { Error403UnathorizedImg } from '@app/assets';
import type { NError403Unauthorized } from '@app/components/Error403Unauthorized/Error403Unauthorized.types';
import { FORBIDDEN_ERROR_MAIN_PART } from '@app/constants';
import { PREFIX } from '@app/constants/appPrefix';

const { Text } = Typography;

const defaultTitle = `${FORBIDDEN_ERROR_MAIN_PART}. Пожалуйста, запросите права у владельца организации.`;

export const Error403Unauthorized: NError403Unauthorized.Main = ({
  title = defaultTitle,
}) => {
  return (
    <div className={`${PREFIX}error-403-unauthorized`}>
      <div className="container">
        <div>
          <img alt="Изображение ошибки" src={Error403UnathorizedImg} />
        </div>
        <Typography.Title level={3}>Нет доступа</Typography.Title>
        <Text type="secondary" style={{ textAlign: 'center' }}>
          {title}
        </Text>
      </div>
    </div>
  );
};
